<div
  class="bl-h-5 d-flex align-items-center justify-content-center border-bottom border-neutral-light"
  *ngIf="content$ | async as content"
>
  <span class="text-bold mx-1" *ngIf="content.heading as heading">{{ heading }}</span>
  <span class="mx-1">{{ content.text }}</span>
  <a
    *ngIf="content.link as link"
    [href]="link.url"
    shrdUicButton
    variant="tertiaryTrivialTextBold"
    class="mx-1 my-0"
    (click)="trackBanner(content)"
  >
    <shrd-uic-svg-icon [icon]="iconName.ARROW_RIGHT"></shrd-uic-svg-icon>
    <span>{{ link.title }}</span>
  </a>
</div>
